import handlerPopup from '../../../../functions/handlerPopup.ts';

const close = function () {
    handlerPopup('companyAmountDocPopup', { isShow: false });
};

export default close;
